import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "115",
  height: "115",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 20a4 4 0 0 1 4-4h95a4 4 0 0 1 4 4v8.5a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V20ZM47.917 55.926a4.133 4.133 0 0 1-5.04.209 18.425 18.425 0 0 0-2.4 4.026 4.133 4.133 0 0 1-1.51 7.91c.049 1.619.307 3.185.748 4.674a4.132 4.132 0 0 1 3.975 7.088 18.527 18.527 0 0 0 3.637 3.114 4.132 4.132 0 0 1 7.66 2.833 18.616 18.616 0 0 0 4.813 0 4.133 4.133 0 0 1 7.661-2.833 18.533 18.533 0 0 0 3.637-3.114 4.132 4.132 0 0 1 3.976-7.088c.44-1.489.698-3.055.748-4.674a4.133 4.133 0 0 1-1.51-7.91 18.43 18.43 0 0 0-2.4-4.026 4.134 4.134 0 0 1-6.155-5.07 18.304 18.304 0 0 0-4.393-1.573 4.133 4.133 0 0 1-7.94 0c-1.546.34-3.02.873-4.393 1.573a4.133 4.133 0 0 1-1.114 4.86Z",
  fill: "#525052"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.895 34.5h93v59a7 7 0 0 1-7 7h-79a7 7 0 0 1-7-7v-59Zm56.13 14.97a20.294 20.294 0 0 0-5.594-2.008 4.133 4.133 0 0 0-8.074 0 20.295 20.295 0 0 0-5.594 2.009 4.133 4.133 0 0 0-6.208 5.115 20.426 20.426 0 0 0-3.107 5.239 4.133 4.133 0 0 0-1.49 7.813 20.41 20.41 0 0 0 1.02 6.253 4.134 4.134 0 0 0 3.83 6.827 20.54 20.54 0 0 0 4.998 4.265 4.133 4.133 0 0 0 7.252 2.682c1.086.178 2.2.27 3.336.27 1.136 0 2.25-.092 3.336-.27a4.132 4.132 0 0 0 7.251-2.682 20.536 20.536 0 0 0 5-4.265 4.133 4.133 0 0 0 3.83-6.827 20.41 20.41 0 0 0 1.019-6.254 4.134 4.134 0 0 0-1.49-7.813 20.42 20.42 0 0 0-3.107-5.239 4.134 4.134 0 0 0-6.208-5.114Z",
  fill: "#525052"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }